import { pxToRem } from '@fluentsms/agentnet-web-components';
import { createStyles, makeStyles, Theme } from '@material-ui/core/styles';
import { filePartyTypeMap, Party, PartyOrderInsightsProps } from 'api/file/interfaces/get-file-order-insights';
import PartyOrderInsights from 'features/files/order-insights/PartyOrderInsights';
import { useMemo } from 'react';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      width: '100%',
      fontFamily: 'AvenirMedium',
      paddingTop: pxToRem(16),
    },
    partiesDetailsContainer: {
      display: 'flex',
      gap: '4px',
      flexDirection: 'column',
      '& p, h2': {
        margin: 0,
      },
    },
    insights: {
      '& *': {
        fontFamily: 'AvenirMedium',
      },
    },
    partiesDetails: {
      display: 'flex',
      flexDirection: 'row',
      gap: pxToRem(12),
      fontSize: pxToRem(12),
      marginBottom: pxToRem(8),
      color: theme.palette.text.secondary,
    },
    partyName: {
      color: theme.palette.text.primary,
      fontFamily: 'Avenir',
      fontSize: pxToRem(16),
      fontStyle: 'normal',
      fontWeight: 800,
      lineHeight: 'normal',
      letterSpacing: pxToRem(1),
    },
  }),
);

interface IParties {
  party: Party;
  enableStatus?: PartyOrderInsightsProps['enableStatus'];
}

const Parties = ({ party, enableStatus }: IParties) => {
  const classes = useStyles();

  const propertyTitle = useMemo(() => {
    const title = [];
    if (party?.address?.address1) {
      title.push(party.address.address1);
    }
    if (party?.address?.city) {
      title.push(party.address.city);
    }
    if (party?.address?.stateOrProvince) {
      title.push(party.address.stateOrProvince);
    }
    if (party?.address?.postalCode) {
      title.push(party.address.postalCode);
    }

    return title.join(', ');
  }, [party?.address?.address1, party?.address?.city, party?.address?.stateOrProvince, party?.address?.postalCode]);

  return (
    <div className={classes.root}>
      <div className={classes.partiesDetailsContainer}>
        <h2 className={classes.partyName}>{party.partyName}</h2>
        <div className={classes.partiesDetails}>
          <p>{filePartyTypeMap[party.filePartyType]}</p>
          <p>{party.partyType}</p>
          <p>{propertyTitle}</p>
        </div>
      </div>

      <div className={classes.insights}>
        <PartyOrderInsights isPdf party={party} enableStatus={enableStatus} />
      </div>
    </div>
  );
};

export default Parties;
